import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import { toBlob } from "html-to-image";
import { PlotlyHTMLElement } from "plotly.js";
import { T } from "services/lang/LanguageService";

const copyChartToClipBoard = (gd: PlotlyHTMLElement) => {
  const el = gd.firstChild?.firstChild as HTMLDivElement;
  const modebar = el.getElementsByClassName("modebar-container")[0];

  el.removeChild(modebar);

  toBlob(el, { skipFonts: true })
    .then(function (blob) {
      navigator.clipboard
        .write([
          new ClipboardItem({
            "image/png": blob!,
          }),
        ])
        .then(() =>
          easasAlert({
            summary: T("alert.clipboard"),
            detail: T("alert.chart-copied-to-clipboard"),
          })
        );
    })
    .catch(function (error) {
      easasAlert({
        summary: T("alert.clipboard"),
        detail: T("alert.this-feature-may-not-be-supported-on-your-browser"),
        severity: "error",
      });
      console.error("Something went wrong!", error);
    })
    .finally(() => {
      el.appendChild(modebar);
    });
};

export default copyChartToClipBoard;
